import React from 'react';
import {
    Container,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Modal,
    Box,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {useState} from 'react';

function Events() {
    const [open, setOpen] = useState(false);
    const [currentPoster, setCurrentPoster] = useState(null);

    const handlePosterClick = (poster) => {
        setCurrentPoster(poster);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentPoster(null);
    };
    const dailyEvents = [
        {day: 'Daily', time: '5:30 AM to 8:30 PM', event: 'Temple Open Hours', notes: ''},
        {day: 'Daily', time: '5:30 PM to 6:00 PM', event: 'Daily Aarti & Pooja', notes: ''}
    ];
    const weeklyEvents = [
        {
            day: 'Thursday',
            time: '5:30 PM to 6:30 PM',
            event: 'Vishnu Sahasranamam',
            notes: 'Curd rice is distributed as special prasadam for devotees'
        },
        {
            day: 'Saturday',
            time: '5:30 PM to 6:45 PM',
            event: 'Hanuman Pooja',
            notes: 'Special Abhishekam & Pooja rituals with Tila Annam and Puli Saadam distributed as prasadam to devotees'
        }
    ];
    const monthlyEvents = [
        {day: 'Monthly', time: 'Varies by month', event: 'Amavasya', notes: ''},
        {day: 'Monthly', time: 'Varies by month', event: 'Moola Natchathiram', notes: ''},
        {day: 'Monthly', time: 'Varies by month', event: 'Sankatahara Chaturthi', notes: ''}
    ];

    const specialEvents = [
        {day: 'April 14th', time: '-', event: 'Vishu (Tamil New Year)', notes: '', poster: ''},
        {day: 'During the month of Aadi', time: '-', event: 'Aadi Moolam', notes: '', poster: ''},
        {day: '27th August, 2025', time: '-', event: 'Vinayagar Chaturthi', notes: '', poster: '/gallery/ganeshchaturthi2025.png'},
        {day: '21st October, 2025', time: '-', event: 'Deepavali Amavasya', notes: 'Maha Abhishekam, Pushpa-Aradhanai, Shoda Upasaram, Sri Hanuman Satanamavali', poster: '/gallery/deepavali2025.png'},
        {
            day: '20th December, 2025',
            time: '-',
            event: '95th Hanuman Jayanthi Festival',
            notes: '',
            poster: ''
        },
    ];

    return (
        <Container id="events" className="events" style={{paddingTop: '2rem', paddingBottom: '2rem'}}>
            <Typography variant="h4" gutterBottom>Daily Events</Typography>
            <TableContainer component={Paper} style={{marginBottom: '2rem'}}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>Day</Typography></TableCell>
                            <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>Time</Typography></TableCell>
                            <TableCell sx={{ width: '25%' }}><Typography variant="body1" paragraph>Event</Typography></TableCell>
                            <TableCell sx={{ width: '35%' }}><Typography variant="body1" paragraph>Notes</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dailyEvents.map((event, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>{event.day}</Typography></TableCell>
                                <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>{event.time}</Typography></TableCell>
                                <TableCell sx={{ width: '25%' }}><Typography variant="body1" paragraph>{event.event}</Typography></TableCell>
                                <TableCell sx={{ width: '35%' }}><Typography variant="body1" paragraph>{event.notes}</Typography></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Typography variant="h4" gutterBottom>Weekly Events</Typography>
            <TableContainer component={Paper} style={{marginBottom: '2rem'}}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>Day</Typography></TableCell>
                            <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>Time</Typography></TableCell>
                            <TableCell sx={{ width: '25%' }}><Typography variant="body1" paragraph>Event</Typography></TableCell>
                            <TableCell sx={{ width: '35%' }}><Typography variant="body1" paragraph>Notes</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {weeklyEvents.map((event, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>{event.day}</Typography></TableCell>
                                <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>{event.time}</Typography></TableCell>
                                <TableCell sx={{ width: '25%' }}><Typography variant="body1" paragraph>{event.event}</Typography></TableCell>
                                <TableCell sx={{ width: '35%' }}><Typography variant="body1" paragraph>{event.notes}</Typography></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Typography variant="h4" gutterBottom>Monthly Events</Typography>
            <TableContainer component={Paper} style={{marginBottom: '2rem'}}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>Day</Typography></TableCell>
                            <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>Time</Typography></TableCell>
                            <TableCell sx={{ width: '25%' }}><Typography variant="body1" paragraph>Event</Typography></TableCell>
                            <TableCell sx={{ width: '35%' }}><Typography variant="body1" paragraph>Notes</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {monthlyEvents.map((event, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>{event.day}</Typography></TableCell>
                                <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>{event.time}</Typography></TableCell>
                                <TableCell sx={{ width: '25%' }}><Typography variant="body1" paragraph>{event.event}</Typography></TableCell>
                                <TableCell sx={{ width: '35%' }}><Typography variant="body1" paragraph>{event.notes}</Typography></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Typography variant="h4" gutterBottom>Annual/Special Events</Typography>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: '25%' }}><Typography variant="body1" paragraph>Day</Typography></TableCell>
                            <TableCell sx={{ width: '15%' }}><Typography variant="body1" paragraph>Time</Typography></TableCell>
                            <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>Event</Typography></TableCell>
                            <TableCell sx={{ width: '30%' }}><Typography variant="body1" paragraph>Notes</Typography></TableCell>
                            <TableCell sx={{ width: '10%' }}><Typography variant="body1" paragraph>Poster</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {specialEvents.map((event, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ width: '25%' }}><Typography variant="body1" paragraph>{event.day}</Typography></TableCell>
                                <TableCell sx={{ width: '15%' }}><Typography variant="body1" paragraph>{event.time}</Typography></TableCell>
                                <TableCell sx={{ width: '20%' }}><Typography variant="body1" paragraph>{event.event}</Typography></TableCell>
                                <TableCell sx={{ width: '30%' }}><Typography variant="body1" paragraph>{event.notes}</Typography></TableCell>
                                <TableCell sx={{ width: '10%' }}>
                                    {event.poster && (
                                        <img src={event.poster} alt={`Poster ${index + 1}`}
                                             style={{width: '50px', height: 'auto', cursor: 'pointer'}}
                                             onClick={() => handlePosterClick(event.poster)}/>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Modal open={open} onClose={handleClose}>
                <Box
                    sx={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: { xs: 1, sm: 4 },
                        outline: 'none',
                        width: { xs: '95vw', sm: '90%' },
                        height: { xs: '95vh', sm: '90%' },
                        maxWidth: '90%',
                        maxHeight: '90%',
                    }}
                >
                    <IconButton
                        onClick={handleClose}
                        sx={{position: 'absolute', top: 0, right: 0}}
                    >
                        <CloseIcon/>
                    </IconButton>
                    <img src={currentPoster} alt="Current Poster" style={{width: '100%', height: '100%', objectFit: 'contain'}}/>
                </Box>
            </Modal>
        </Container>
    );
}

export default Events;
